import moment from 'moment'
import React from 'react'

import { useChildrenServiceOrders } from '../_load/ChildrenServiceOrdersLoader'
import Separator from '../../../../components/pdf/Separator'
import Grid, { Col } from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import Text from '../../../../components/pdf/Text'
import View from '../../../../components/pdf/View'

const FifthPage = () => {
  const childrenServiceOrder = useChildrenServiceOrders()
  const childrenServiceOrders = childrenServiceOrder.filter(so => so.checklist.id === 8)

  const completedDateTime = childrenServiceOrders[0]?.events.filter(event => event?.status?.id === 8)[0]?.eventDate
  const formattedCompletedDateTimeInFull = moment(completedDateTime).format('DD [de] MMMM [de] YYYY')

  return (
    <View pageBreakAfter>
      <Grid direction="column" align="start">
        <Col>
          <Image src="/pdfs/sannygold/logo.jpg" maxWidth={100} />
        </Col>
      </Grid>
      <Separator weight={6} />
      <Grid direction="column">
        <Col>
          <Text bold align="center" color="#938953" size={18}>
            Informações Complementares:
          </Text>
          <Separator weight={6} />
          <Grid direction="column" style={{ gap: 5 }} align="start">
            <Text> - Esta proposta é valida apenas para o evento descrito acima.</Text>
            <Text> - Esta proposta é válida por 30 dias.</Text>
            <Text bold> - Disponibilidade sujeita a reserva, que só será realizada após depósito do sinal.</Text>
            <Text>
              {' '}
              <strong> - Forma de pagamento:</strong> A proposta inclui frete, montagem e desmontagem.
            </Text>
            <Text> - O trailer deve ser usado em piso plano e nivelado e respeitando as dimensões do mesmo.</Text>
            <Text>
              {' '}
              - O Cliente se responsabiliza pela segurança do equipamento e danos decorrentes do mal-uso ou vandalismo.
            </Text>
          </Grid>
          <Separator weight={20} />
          <Text>Niterói, {formattedCompletedDateTimeInFull}</Text>
          <Separator weight={20} />
          <Text>Atenciosamente,</Text>
          <Separator weight={10} />
          <Image src="/pdfs/sannygold/sannygold-sign.jpg" maxWidth={200} />
        </Col>
      </Grid>
      <Separator weight={100} />

      <Grid justify="center">
        <Col>
          <Image src="/pdfs/sannygold/instagram.jpg" maxWidth={200} />
        </Col>
      </Grid>
    </View>
  )
}

export default FifthPage
